import Inputmask from "inputmask"
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export class FuncionalMask {
  constructor() {
    this.cpfElement = document.querySelector("#input-cpf");
    this.dataNascimentoElement = document.querySelectorAll("#input-Nascimento");
    this.cepElement = document.querySelector("#input-CEP");
    this.numeroElement = document.querySelector("#input-Numero");
    this.telefoneElement = document.querySelector("#input-Telefone");
    this.telefoneComercialElement = document.querySelector("#input-TelefoneComercial");
    this.telefoneCelularElement = document.querySelector("#input-TelefoneCelular");
    this.crmElement = document.querySelector("#input-NumeroRegistroConselho");
    //this.calendar = document.querySelectorAll(".calendar-fp");

    this.init()
  }

  init() {
    Inputmask.extendDefaults({
      'autoUnmask': true
    });

    if (this.cpfElement)
      Inputmask("999.999.999-99").mask(this.cpfElement);
    if (this.dataNascimentoElement)
      Array.from(this.dataNascimentoElement, dtNasc => {
        Inputmask("date").mask(dtNasc);
      });
    if (this.cepElement)
      Inputmask("99999-999").mask(this.cepElement);
    if (this.numeroElement)
      Inputmask("integer", {rightAlign: false}).mask(this.numeroElement);
    if (this.telefoneElement)
      Inputmask({"mask": "(99) 9999-9999", rightAlign: false}).mask(this.telefoneElement);
    if (this.telefoneComercialElement)
      Inputmask({"mask": "(99) 9999-9999", rightAlign: false}).mask(this.telefoneComercialElement);
    if (this.telefoneCelularElement)
      Inputmask({"mask": "(99) 99999-9999", rightAlign: false}).mask(this.telefoneCelularElement);
    if (this.crmElement)
      Inputmask("integer", {rightAlign: false}).mask(this.crmElement)
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/masks.js